<!-- app-header -->
<header class="app-header">

    <!-- Start::main-header-container -->
    <div class="main-header-container container-fluid">
  
      <!-- Start::header-content-left -->
      <div class="header-content-left">
  
        <!-- Start::header-element -->
        <div class="">
          <div class="horizontal-logo">
            <a routerLink="/dashboard/sales" class="header-logo">
              <img src="./assets/images/brand-logos/logo-container.png" alt="logo" class="logo-container">
              <img src="./assets/images/brand-logos/toggle-logo.png" alt="logo" class="toggle-logo">
              <img src="./assets/images/brand-logos/desktop-dark.png" alt="logo" class="desktop-dark">
              <img src="./assets/images/brand-logos/toggle-dark.png" alt="logo" class="toggle-dark">
            </a>
          </div>
        </div>
        <!-- End::header-element -->
  
        <!-- Start::header-element -->
        <div class="header-element mx-lg-0 mx-2">
          <a aria-label="Hide Sidebar"
            class="sidemenu-toggle header-link animated-arrow hor-toggle horizontal-navtoggle"
             data-bs-toggle="sidebar" (click)="toggleSidebar()"><span ></span></a>
          </div>
          <!-- End::header-element -->
  
          <!-- Start::header-element -->
          <div class="header-element header-search d-md-block d-none">
            <!-- Start::header-link -->
            <input type="text" class="header-search-bar form-control border-0 bg-body"
              placeholder="Search for Results..." autocomplete="off" (click)="SearchHeader()" [(ngModel)]="text" [ngModelOptions]="{standalone: true}"
              (keyup)="Search(text)">
            <a href="javascript:void(0);" class="header-search-icon border-0">
              <i class="bi bi-search"></i>
            </a>
            <!-- End::header-link -->
            @if("menuItems?.length>0"){
              <div class="">
              <ul class="" (click)="clearSearch()">
    
                  @for(menuItem of menuItems | slice:0:5;track $index){
                      <li class="p-1 d-flex align-items-center text-muted mb-2 search-app"  [routerLink]="menuItem?.path" (click)="clearSearch()">
                          <a [routerLink]="menuItem?.path"><span><i
                                      class='fa fa-angle-double-right me-2'></i>{{menuItem?.title}}</span></a>
                      </li>
                  }
                 
              </ul>
          </div>
          }
          @else{
              <ng-template>
                  <ul class="ps-2">
                      <li class="p-1 d-flex align-items-center text-muted mb-2 search-app">
                          <a ><span><i
                                      class='fa fa-angle-double-right me-2'></i>No Search Result Found with "{{text}}"</span></a>
                      </li>
                   
                  </ul>
                </ng-template>
          }
          </div>
          <!-- End::header-element -->
  
          <!-- Start::header-element -->
          <div class="header-element ms-3 d-lg-block d-none my-auto">
            <!-- Start::dashboards list -->
            <div ngbDropdown class="dropdown my-auto" (click)="toggleDropdown()">
              <a ngbDropdownToggle href="javascript:void(0);"    
                class="btn bg-body header-dashboards-button text-start d-flex align-items-center justify-content-between"
                data-bs-toggle="dropdown" aria-expanded="false">{{ selectedItem }}
                <i class="ri-arrow-down-s-line align-middle ms-1 d-inline-block"></i>
              </a>
              <ul ngbDropdownMenu class="dropdown-menu dashboard-dropdown" role="menu">
                <li><a ngbDropdownItem class="dropdown-item dashboards-dropdown-item"
               [routerLink]="[ 'dashboard', 'sales']" (click)="handleItemClick('Sales Dashboard')" [class.active]="selectedItem === 'Sales Dashboard'">Sales Dashboard</a></li>
                <li><a ngbDropdownItem class="dropdown-item dashboards-dropdown-item"
                  [routerLink]="[ 'dashboard', 'analytics']" (click)="handleItemClick('Analytics Dashboard')" [class.active]="selectedItem === 'Analytics Dashboard'">Analytics Dashboard</a></li>
                <li><a ngbDropdownItem class="dropdown-item dashboards-dropdown-item"
                  [routerLink]="[ 'dashboard', 'ecommerce']" (click)="handleItemClick('Ecommerce Dashboard')">Ecommerce Dashboard</a></li>
                <li><a ngbDropdownItem class="dropdown-item dashboards-dropdown-item"
                  [routerLink]="[ 'dashboard', 'crm']" (click)="handleItemClick('CRM Dashboard')">CRM Dashboard</a></li>
                <li><a ngbDropdownItem class="dropdown-item dashboards-dropdown-item"
                  [routerLink]="[ 'dashboard', 'hrm']" (click)="handleItemClick('HRM Dashboard')">HRM Dashboard</a></li>
                <li><a ngbDropdownItem class="dropdown-item dashboards-dropdown-item"
                  [routerLink]="[ 'dashboard', 'nft']" (click)="handleItemClick('NFT Dashboard')">NFT Dashboard</a></li>
                <li><a ngbDropdownItem class="dropdown-item dashboards-dropdown-item"
                  [routerLink]="[ 'dashboard', 'crypto']" (click)="handleItemClick('Crypto Dashboard')">Crypto Dashboard</a></li>
                <li><a ngbDropdownItem class="dropdown-item dashboards-dropdown-item"
                  [routerLink]="[ 'dashboard', 'jobs']" (click)="handleItemClick('Jobs Dashboard')">Jobs Dashboard</a></li>
                <li><a ngbDropdownItem class="dropdown-item dashboards-dropdown-item"
                  [routerLink]="[ 'dashboard', 'projects']" (click)="handleItemClick('Projects Dashboard')">Projects Dashboard</a></li>
                <li><a ngbDropdownItem class="dropdown-item dashboards-dropdown-item"
                  [routerLink]="[ 'dashboard', 'courses']" (click)="handleItemClick('Courses Dashboard')">Courses Dashboard</a></li>
                <li><a ngbDropdownItem class="dropdown-item dashboards-dropdown-item"
                  [routerLink]="[ 'dashboard', 'stocks']" (click)="handleItemClick('Stocks Dashboard')">Stocks Dashboard</a></li>
                <li><a ngbDropdownItem class="dropdown-item dashboards-dropdown-item"
                  [routerLink]="[ 'dashboard', 'personal']" (click)="handleItemClick('Personal Dashboard')">Personal Dashboard</a></li>
                <li><a ngbDropdownItem class="dropdown-item dashboards-dropdown-item"
                  [routerLink]="[ 'dashboard', 'customer']" (click)="handleItemClick('Customer Dashboard')">Customer Dashboard</a></li>
              </ul>
            </div>
            <!-- End::dashboards list -->
          </div>
          <!-- End::header-element -->
  
        </div>
        <!-- End::header-content-left -->
  
  
        <!-- Start::header-content-right -->
        <ul class="header-content-right">
  
          <!-- Start::header-element -->
          <li class="header-element d-md-none d-block">
            <a href="javascript:void(0);" class="header-link" data-bs-toggle="modal"
              data-bs-target="#header-responsive-search" (click)="openModal(content)">
              <!-- Start::header-link-icon -->
              <i class="bi bi-search header-link-icon"></i>
              <!-- End::header-link-icon -->
            </a>
          </li>
          <!-- End::header-element -->
  
          <!-- Start::header-element -->
          <li ngbDropdown class="header-element country-selector" [autoClose]="'outside'">
            <!-- Start::header-link|dropdown-toggle -->
            <a ngbDropdownToggle href="javascript:void(0);" class="header-link dropdown-toggle"
              data-bs-auto-close="outside" data-bs-toggle="dropdown">
              <img src="./assets/images/flags/us_flag.jpg" alt="img" class="rounded-circle">
            </a>
            <!-- End::header-link|dropdown-toggle -->
            <ul ngbDropdownMenu class="main-header-dropdown dropdown-menu dropdown-menu-end full-width"
              data-popper-placement="none">
              <li>
                <a ngbDropdownItem class="dropdown-item d-flex align-items-center" href="javascript:void(0);">
                  <span class="avatar avatar-xs lh-1 me-2">
                    <img src="./assets/images/flags/us_flag.jpg" alt="img">
                  </span>
                  English
                </a>
              </li>
              <li>
                <a ngbDropdownItem class="dropdown-item d-flex align-items-center" href="javascript:void(0);">
                  <span class="avatar avatar-xs lh-1 me-2">
                    <img src="./assets/images/flags/spain_flag.jpg" alt="img">
                  </span>
                  Spanish
                </a>
              </li>
              <li>
                <a ngbDropdownItem class="dropdown-item d-flex align-items-center" href="javascript:void(0);">
                  <span class="avatar avatar-xs lh-1 me-2">
                    <img src="./assets/images/flags/french_flag.jpg" alt="img">
                  </span>
                  French
                </a>
              </li>
              <li>
                <a ngbDropdownItem class="dropdown-item d-flex align-items-center" href="javascript:void(0);">
                  <span class="avatar avatar-xs lh-1 me-2">
                    <img src="./assets/images/flags/germany_flag.jpg" alt="img">
                  </span>
                  German
                </a>
              </li>
              <li>
                <a ngbDropdownItem class="dropdown-item d-flex align-items-center" href="javascript:void(0);">
                  <span class="avatar avatar-xs lh-1 me-2">
                    <img src="./assets/images/flags/italy_flag.jpg" alt="img">
                  </span>
                  Italian
                </a>
              </li>
              <li>
                <a ngbDropdownItem class="dropdown-item d-flex align-items-center" href="javascript:void(0);">
                  <span class="avatar avatar-xs lh-1 me-2">
                    <img src="./assets/images/flags/russia_flag.jpg" alt="img">
                  </span>
                  Russian
                </a>
              </li>
            </ul>
          </li>
          <!-- End::header-element -->
  
          <!-- Start::header-element themes-->
          <li class="header-element header-theme-mode">
            <!-- Start::header-link|layout-setting -->
            <a href="javascript:void(0);" class="header-link layout-setting">
              <span class="light-layout" (click)="updateTheme('dark')">
                <!-- Start::header-link-icon -->
                <i class="bi bi-moon header-link-icon"></i>
                <!-- End::header-link-icon -->
              </span>
              <span class="dark-layout"  (click)="updateTheme('light')">
                <!-- Start::header-link-icon -->
                <i class="bi bi-brightness-high header-link-icon"></i>
                <!-- End::header-link-icon -->
              </span>
            </a>
            <!-- End::header-link|layout-setting -->
          </li>
          <!-- End::header-element -->
  
          <!-- Start::header-element  cart-->
          <li ngbDropdown  class="header-element cart-dropdown" [autoClose]="'outside'">
            <!-- Start::header-link|dropdown-toggle -->
            <a ngbDropdownToggle href="javascript:void(0);" class="header-link dropdown-toggle" data-bs-auto-close="outside"
              data-bs-toggle="dropdown">
              <i class="bi bi-cart2 header-link-icon"></i>
              <span class="badge bg-primary rounded-pill header-icon-badge" id="cart-icon-badge">{{ cartItemCount }}</span>
            </a>
            <!-- End::header-link|dropdown-toggle -->
            <!-- Start::main-header-dropdown -->
            <div ngbDropdownMenu  class="main-header-dropdown dropdown-menu dropdown-menu-end" data-popper-placement="none">
              <div class="p-3">
                <div class="d-flex align-items-center justify-content-between">
                  <p class="mb-0 fs-16">Cart Items<span
                    class="badge bg-success-transparent ms-1 fs-12 rounded-circle"
                  id="cart-data">{{ cartItemCount }}</span></p>
                  <span><span class="text-muted me-1">Total:</span><span
                class="text-primary fw-medium">$14,289</span></span>
              </div>
            </div>
            <div class="dropdown-divider"></div>
  
            <overlay-scrollbars [defer]>
              <ul class="list-unstyled mb-0" id="header-cart-items-scroll">
                <li ngbDropdownItem class="dropdown-item" (click)="handleCardClick($event)" id="row1">
                  <div class="d-flex align-items-start cart-dropdown-item">
                    <img src="./assets/images/ecommerce/jpg/9.jpg" alt="img" class="avatar me-3">
                    <div class="flex-grow-1">
                      <div class="d-flex align-items-start justify-content-between mb-0">
                        <div class="mb-0 fs-13 text-dark">
                          <a routerLink="/pages/ecommerce/cart">Pink High Heel Sandals</a>
                        </div>
                        <div>
                          <span class="fw-medium mb-1">$499.00</span>
                          <a href="javascript:void(0);" (click)="removeRow('row1')"
                            class="header-cart-remove float-end dropdown-item-close"><i
                          class="ti ti-x"></i></a>
                        </div>
                      </div>
                      <div class="min-w-fit-content d-flex align-items-start justify-content-between">
                        <ul class="header-product-item d-flex">
                          <li>Quantity: 01</li>
                          <li><span class="badge bg-light text-default border">In Stock</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
                <li ngbDropdownItem class="dropdown-item" (click)="handleCardClick($event)" id="row2">
                  <div class="d-flex align-items-start cart-dropdown-item">
                    <img src="./assets/images/ecommerce/jpg/10.jpg" alt="img" class="avatar me-3">
                    <div class="flex-grow-1">
                      <div class="d-flex align-items-start justify-content-between mb-0">
                        <div class="mb-0 fs-13 text-dark">
                          <a routerLink="/pages/ecommerce/cart">Blue Denim Jacket</a>
                        </div>
                        <div>
                          <span class="fw-medium mb-1">$129.79</span>
                          <a href="javascript:void(0);"(click)="removeRow('row2')"
                            class="header-cart-remove float-end dropdown-item-close"><i
                          class="ti ti-x"></i></a>
                        </div>
                      </div>
                      <div class="min-w-fit-content d-flex align-items-start justify-content-between">
                        <ul class="header-product-item">
                          <li>Quantity: 02</li>
                          <li><span class="badge bg-light text-default border">In Stock</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
                <li ngbDropdownItem class="dropdown-item" (click)="handleCardClick($event)" id="row3">
                  <div class="d-flex align-items-start cart-dropdown-item">
                    <img src="./assets/images/ecommerce/jpg/13.jpg" alt="img" class="avatar me-3">
                    <div class="flex-grow-1">
                      <div class="d-flex align-items-start justify-content-between mb-0">
                        <div class="mb-0 fs-13 text-dark">
                          <a routerLink="/pages/ecommerce/cart">Yellow Backpack (24L)</a>
                        </div>
                        <div>
                          <span class="fw-medium mb-1">$99.99</span>
                          <a href="javascript:void(0);" (click)="removeRow('row3')"
                            class="header-cart-remove float-end dropdown-item-close"><i
                          class="ti ti-x"></i></a>
                        </div>
                      </div>
                      <div class="min-w-fit-content d-flex align-items-start justify-content-between">
                        <ul class="header-product-item d-flex">
                          <li>Quantity: 01</li>
                          <li><span class="badge bg-light text-default border">In Stock</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
                <li ngbDropdownItem class="dropdown-item" (click)="handleCardClick($event)" id="row4">
                  <div class="d-flex align-items-start cart-dropdown-item">
                    <img src="./assets/images/ecommerce/jpg/16.jpg" alt="img" class="avatar me-3">
                    <div class="flex-grow-1">
                      <div class="d-flex align-items-start justify-content-between mb-0">
                        <div class="mb-0 fs-13 text-dark">
                          <a routerLink="/pages/ecommerce/cart">Multi Color Dress for Girls (3Y - 4Y)</a>
                        </div>
                        <div>
                          <span class="fw-medium mb-1">$1.499.00</span>
                          <a href="javascript:void(0);" (click)="removeRow('row4')"
                            class="header-cart-remove float-end dropdown-item-close"><i
                          class="ti ti-x"></i></a>
                        </div>
                      </div>
                      <div class="min-w-fit-content d-flex align-items-start justify-content-between">
                        <ul class="header-product-item d-flex">
                          <li>Quantity: 02</li>
                          <li><span class="badge bg-danger-transparent border">Out Of Stock</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
              <li ngbDropdownItem class="dropdown-item" (click)="handleCardClick($event)" id="row5">
                <div class="d-flex align-items-start cart-dropdown-item">
                  <img src="./assets/images/ecommerce/jpg/18.jpg" alt="img" class="avatar me-3">
                  <div class="flex-grow-1">
                    <div class="d-flex align-items-start justify-content-between mb-0">
                      <div class="mb-0 fs-13 text-dark">
                        <a routerLink="/pages/ecommerce/cart">Xavier Smart Watch</a>
                      </div>
                      <div>
                        <span class="fw-medium mb-1">$49.79</span>
                        <a href="javascript:void(0);" (click)="removeRow('row5')"
                          class="header-cart-remove float-end dropdown-item-close"><i
                        class="ti ti-x"></i></a>
                      </div>
                    </div>
                    <div class="d-flex align-items-start justify-content-between">
                      <ul class="header-product-item d-flex">
                        <li>Quantity: 03</li>
                        <li><span class="badge bg-light text-default border">In Stock</span></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </overlay-scrollbars>
          @if (!isCartEmpty) {
  
            <div  class="p-3 empty-header-item border-top">
              <div class="text-center">
                <a routerLink="/pages/ecommerce/checkout" class="link-primary text-decoration-underline">Proceed to
                checkout</a>
              </div>
            </div>
          }
  
  
          <div  class="p-5 empty-item " [class.d-none]="!isCartEmpty">
            <div class="text-center">
              <span class="avatar avatar-xl avatar-rounded bg-primary-transparent">
                <i class="ri-shopping-cart-2-line fs-2"></i>
              </span>
              <h6 class="fw-medium mb-1 mt-3">Your Cart is Empty</h6>
              <span class="mb-3 fw-normal fs-13 d-block">Add some items to make me happy :)</span>
              <a routerLink="/pages/ecommerce/products" class="btn btn-primary btn-wave btn-sm m-1" data-abc="true">continue
                shopping <i class="bi bi-arrow-right ms-1"></i></a>
              </div>
            </div>
  
          </div>
          <!-- End::main-header-dropdown -->
        </li>
        <!-- End::header-element -->
  
        <!-- Start::header-element  notifications-->
        <li ngbDropdown class="header-element notifications-dropdown d-xl-block d-none" [autoClose]="'outside'">
          <!-- Start::header-link|dropdown-toggle -->
          <a ngbDropdownToggle href="javascript:void(0);" class="header-link dropdown-toggle" data-bs-toggle="dropdown"
            data-bs-auto-close="outside" id="messageDropdown" aria-expanded="false">
            <i class="bi bi-bell header-link-icon"></i>
            <span class="header-icon-pulse bg-secondary rounded pulse pulse-secondary"></span>
          </a>
          <!-- End::header-link|dropdown-toggle -->
          <!-- Start::main-header-dropdown -->
          <div ngbDropdownMenu   class="main-header-dropdown dropdown-menu dropdown-menu-end" data-popper-placement="none">
            <div  class="p-3">
              <div class="d-flex align-items-center justify-content-between">
                <p class="mb-0 fs-16">Notifications</p>
                <span class="badge bg-secondary-transparent" id="notifiation-data">{{ notificationCount }} Unread</span>
              </div>
            </div>
            <div class="dropdown-divider"></div>
            <overlay-scrollbars [defer]>
              <ul class="list-unstyled mb-0" id="header-notification-scroll" (click)="handleCardClick($event)">
                <li ngbDropdownItem class="dropdown-item" id="not1">
                  <div class="d-flex align-items-center">
                    <div class="pe-2 lh-1">
                      <span class="avatar avatar-rounded">
                        <img src="./assets/images/faces/11.jpg" alt="">
                      </span>
                    </div>
                    <div class="flex-grow-1 d-flex align-items-center justify-content-between">
                      <div>
                        <p class="mb-0 fw-medium"><a routerLink="pages/notifications">John Doe</a></p>
                        <span class="text-muted fw-normal fs-12 header-notification-text">Hey there!
                        What's up?</span>
                      </div>
                      <div>
                        <a href="javascript:void(0);"(click)="removeNotify('not1')"
                          class="min-w-fit-content text-muted me-1 dropdown-item-close1"><i
                        class="ti ti-x fs-16"></i></a>
                      </div>
                    </div>
                  </div>
                </li>
                <li ngbDropdownItem class="dropdown-item" id="not2">
                  <div class="d-flex align-items-center">
                    <div class="pe-2 lh-1">
                      <span class="avatar bg-secondary-transparent avatar-rounded">
                        <img src="./assets/images/faces/21.jpg" alt="">
                      </span>
                    </div>
                    <div class="flex-grow-1 d-flex align-items-center justify-content-between">
                      <div>
                        <p class="mb-0 fw-medium"><a routerLink="pages/notifications">Customer Support</a></p>
                        <span class="text-muted fw-normal fs-12 header-notification-text">Great job on
                        resolving the issue! Thank you!</span>
                      </div>
                      <div>
                        <a href="javascript:void(0);" (click)="removeNotify('not2')"
                          class="min-w-fit-content text-muted me-1 dropdown-item-close1"><i
                        class="ti ti-x"></i></a>
                      </div>
                    </div>
                  </div>
                </li>
                <li ngbDropdownItem class="dropdown-item" id="not3">
                  <div class="d-flex align-items-center">
                    <div class="pe-2 lh-1">
                      <span class="avatar bg-pink-transparent avatar-rounded">
                        <img src="./assets/images/faces/20.jpg" alt="">
                      </span>
                    </div>
                    <div class="flex-grow-1 d-flex align-items-center justify-content-between">
                      <div>
                        <p class="mb-0 fw-medium"><a routerLink="pages/notifications">Digital Marketing
                        Trends</a></p>
                        <span class="text-muted fw-normal fs-12 header-notification-text">Next Thursday
                        at 2:30 PM</span>
                      </div>
                      <div>
                        <a href="javascript:void(0);" (click)="removeNotify('not3')"
                          class="min-w-fit-content text-muted me-1 dropdown-item-close1"><i
                        class="ti ti-x"></i></a>
                      </div>
                    </div>
                  </div>
                </li>
                <li ngbDropdownItem class="dropdown-item" id="not4">
                  <div class="d-flex align-items-center">
                    <div class="pe-2 lh-1">
                      <span class="avatar bg-danger-transparent avatar-rounded"><i
                      class="ti ti-circle-check fs-18"></i></span>
                    </div>
                    <div class="flex-grow-1 d-flex align-items-center justify-content-between">
                      <div>
                        <p class="mb-0 fw-medium"><a routerLink="pages/notifications">Amount: $50.00 paid for
                        the order</a></p>
                        <span class="text-muted fw-normal fs-12 header-notification-text">Transaction
                        ID: 123456789</span>
                      </div>
                      <div>
                        <a href="javascript:void(0);" (click)="removeNotify('not4')"
                          class="min-w-fit-content text-muted me-1 dropdown-item-close1"><i
                        class="ti ti-x"></i></a>
                      </div>
                    </div>
                  </div>
                </li>
                <li ngbDropdownItem class="dropdown-item" id="not5">
                  <div class="d-flex align-items-center">
                    <div class="pe-2 lh-1">
                      <span class="avatar bg-success-transparent avatar-rounded">
                        <img src="./assets/images/faces/6.jpg" alt="">
                      </span>
                    </div>
                    <div class="flex-grow-1 d-flex align-items-center justify-content-between">
                      <div>
                        <p class="mb-0 fw-medium"><a routerLink="pages/notifications">Samantha</a></p>
                        <span class="text-muted fw-normal fs-12 header-notification-text">Would you like
                        to connect?</span>
                      </div>
                      <div>
                        <a href="javascript:void(0);" (click)="removeNotify('not5')"
                          class="min-w-fit-content text-muted me-1 dropdown-item-close1"><i
                        class="ti ti-x"></i></a>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </overlay-scrollbars>
            @if (!isNotifyEmpty) {
  
              <div class="p-3 empty-header-item1 border-top">
                <div class="text-center">
                  <a routerLink="pages/notifications" class="link-primary text-decoration-underline">View All</a>
                </div>
              </div>
            }
            <div class="p-5 empty-item1 " [class.d-none]="!isNotifyEmpty">
              <div class="text-center">
                <span class="avatar avatar-xl avatar-rounded bg-secondary-transparent">
                  <i class="ri-notification-off-line fs-2"></i>
                </span>
                <h6 class="fw-medium mt-3">No New Notifications</h6>
              </div>
            </div>
          </div>
          <!-- End::main-header-dropdown -->
        </li>
        <!-- End::header-element -->
  
        <!-- Start::header-element fullscreen -->
        <li class="header-element header-fullscreen" appFullscreen>
          <!-- Start::header-link -->
          <a  href="javascript:void(0);"  class="header-link" (click)="toggleFullscreen()">
            <i class="bi bi-fullscreen full-screen-open header-link-icon"  [ngClass]="{ 'd-none': isFullscreen }"></i>
            <i class="bi bi-fullscreen-exit full-screen-close header-link-icon d-none"  [ngClass]="{ 'd-none': !isFullscreen }"></i>
          </a>
          <!-- End::header-link -->
        </li>
        <!-- End::header-element -->
  
        <!-- Start::header-element profile -->
        <li ngbDropdown  class="header-element">
          <!-- Start::header-link|dropdown-toggle -->
          <a ngbDropdownToggle href="javascript:void(0);" class="header-link dropdown-toggle" id="mainHeaderProfile"
            data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
            <div class="d-flex align-items-center">
              <div class="me-sm-2 me-0">
                <img src="./assets/images/faces/9.jpg" alt="img" class="avatar avatar-sm avatar-rounded">
              </div>
              <div class="d-xl-block d-none lh-1">
                <span class="fw-medium lh-1">Mr. Stark</span>
              </div>
            </div>
          </a>
          <!-- End::header-link|dropdown-toggle -->
          <ul ngbDropdownMenu  class="main-header-dropdown dropdown-menu pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end full-width"
            aria-labelledby="mainHeaderProfile">
            <li><a ngbDropdownItem class="dropdown-item d-flex align-items-center" routerLink="/pages/profile"><i
            class="bi bi-person fs-18 me-2 op-7"></i>Profile</a></li>
            <li><a ngbDropdownItem class="dropdown-item d-flex align-items-center" routerLink="/pages/email/mailapp"><i
            class="bi bi-envelope fs-16 me-2 op-7"></i>Inbox <span
          class="ms-auto badge bg-light border text-default">19</span></a></li>
          <li><a ngbDropdownItem class="dropdown-item d-flex align-items-center" routerLink="/pages/to-do-list"><i
          class="bi bi-check-square fs-16 me-2 op-7"></i>Task Manager</a></li>
          <li><a ngbDropdownItem class="dropdown-item d-flex align-items-center" routerLink="/pages/email/mailsettings"><i
          class="bi bi-gear fs-16 me-2 op-7"></i>Settings</a></li>
          <li><a ngbDropdownItem class="dropdown-item d-flex align-items-center" routerLink="/pages/chat"><i
          class="bi bi-headset fs-18 me-2 op-7"></i>Support</a></li>
          <li><a ngbDropdownItem class="dropdown-item d-flex align-items-center" routerLink="/authentication/sign-in/cover"><i
          class="bi bi-box-arrow-right fs-18 me-2 op-7"></i>Log Out</a></li>
        </ul>
      </li>
      <!-- End::header-element -->
  

  
    </ul>
    <!-- End::header-content-right -->
    <!-- End::header-content-right -->
  </div>
  <!-- End::main-header-container -->
  
  </header>
  <!-- /app-header -->
  <ng-template #content let-modal>
          <div class="modal-body">
              <div class="input-group">
                  <input type="text" class="form-control border-end-0" placeholder="Search Anything ..."
                      aria-label="Search Anything ..." aria-describedby="button-addon2">
                  <button class="btn btn-primary" type="button"
                      id="button-addon2"><i class="bi bi-search"></i></button>
              </div>
          </div>
     
  
  </ng-template>
  